import React from 'react';
import { Button } from '../../ui/Button.js';

/**
 * Comp `.chip` — a pill button whose only job is to say something back into the
 * conversation. `ghost` is the muted variant used for opt-out options
 * ("Something else", "Nothing, looks good").
 */
export function ActionChip({
  children,
  onClick,
  variant = 'default',
  disabled,
  title,
}: {
  children: React.ReactNode;
  onClick: () => void;
  variant?: 'default' | 'ghost';
  disabled?: boolean;
  title?: string;
}) {
  return (
    <Button
      variant={variant === 'ghost' ? 'ghost' : 'secondary'}
      size="sm"
      className="rounded-full"
      onClick={onClick}
      disabled={disabled}
      title={title}
    >
      {children}
    </Button>
  );
}
